<template>
  <div class="content order-list">
    <navBar />
    <div class="operation-content">
      <a-button type="primary" @click="visible = true">
        <a-icon type="plus"></a-icon>批量导入发货
      </a-button>
    </div>
    <div class="form-content">
      <a-form-model
        layout="inline"
        ref="ruleForm"
        :model="form"
        :wrapper-col="wrapperCol"
      >
        <a-row :gutter="10" type="flex">
          <a-col :span="8">
            <a-form-model-item ref="order_sn_list">
              <a-input
                v-model="form.order_sn_list"
                placeholder="平台订单号，多个用“逗号,”分隔"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item ref="tracking_number_list">
              <a-input
                v-model="form.tracking_number_list"
                placeholder="面单号，多个用“逗号,”分隔"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="4">
            <a-form-model-item>
              <a-select
                style="width: 100%"
                v-model="form.pay_status"
                placeholder="付款状态"
                :dropdown-match-select-width="false"
              >
                <a-select-option value="0">未付款</a-select-option>
                <a-select-option value="1">已付款</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="8">
            <a-form-model-item required>
              <date-range-picker
                id="pay-time"
                :needhms="true"
                :placeholder="$t(`form.OrderTime`)"
                @get_date="get_order_time"
                :start-time="form.start_time"
                :end-time="form.end_time"
              ></date-range-picker>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="10" type="flex">
          <!-- <a-col :span="6">
            <a-form-model-item required>
              <a-range-picker
                v-model="form.receiveTime"
                style="width: 100%"
                @change="onChange2"
                :placeholder="['签收开始时间', '签收结束时间']"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item required>
              <a-range-picker
                v-model="form.payTime"
                style="width: 100%"
                @change="onChange3"
                :placeholder="['付款开始时间', '付款结束时间']"
              />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.desc" placeholder="支付方式" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.desc" placeholder="商家编码" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.goods_name" placeholder="宝贝名称" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.desc" placeholder="收件人" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.mobile" placeholder="手机号" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.desc" placeholder="用户ID" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="4">
            <a-form-model-item>
              <a-select
                style="width: 100%"
                v-model="form.order_status"
                placeholder="订单状态"
                allowClear
                :dropdown-match-select-width="false"
              >
                <a-select-option
                  :value="item.value"
                  v-for="item in order_status_list"
                  :key="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="4">
            <a-form-model-item>
              <a-select style="width: 100%" v-model="form.note">
                <a-select-option :value="0">无备注</a-select-option>
                <a-select-option :value="1">全部备注</a-select-option>
                <a-select-option :value="2">顾客备注</a-select-option>
                <a-select-option :value="3">小二备注</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.desc" placeholder="备注内容" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-input v-model="form.desc" placeholder="仓库" />
            </a-form-model-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-model-item>
              <a-select
                style="width: 100%"
                v-model="form.shipping_id"
                allowClear
                placeholder="快递"
                :dropdown-match-select-width="false"
              >
                <a-select-option
                  :value="item.value"
                  v-for="item in shipping_list"
                  :key="item.value"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-select
                style="width: 100%"
                v-model="form.platform"
                allowClear
                placeholder="平台"
                :dropdown-match-select-width="false"
              >
                <a-select-option
                  :value="item.value"
                  v-for="item in platformList"
                  :key="item.value"
                  >{{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="getOrderList">搜索</a-button>
              <a-button type="primary" @click="onExport">导出</a-button>
              <a-button @click="resetForm">重置</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-spin :spinning="loading" tip="数据加载中...">
      <div class="table-content">
        <div class="table-header">
          <div class="tab-content">
            <a-tabs
              size="small"
              v-model="form.order_status"
              @change="changeTab"
            >
              <a-tab-pane :key="undefined" tab="全部"></a-tab-pane>
              <a-tab-pane
                :key="item.value"
                :tab="item.name"
                v-for="item in order_status_list"
              ></a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <div class="table-body">
          <a-table
            rowKey="platform_order_sn"
            size="small"
            :columns="columns"
            :data-source="table_data"
            :pagination="false"
          >
            <span slot="platform_name" slot-scope="text">
              <span>{{ platformNameMapping[text] }}</span>
            </span>
            <span slot="user" slot-scope="text, record">
              <span>{{ text }}</span>
              <span v-if="text && record.uid">/</span>
              <span>{{ record.uid }}</span>
            </span>
            <span slot="receiver_name" slot-scope="text, record">
              <p>{{ text }}</p>
              <p>{{ record.mobile }}</p>
            </span>
            <span slot="address" slot-scope="text, record">
              <p>
                {{ record.province_name }}{{ record.city_name
                }}{{ record.district_name }}{{ text }}
              </p>
            </span>
            <span slot="shipping" slot-scope="text, record">
              <p>{{ text }}</p>
              <p>{{ record.tracking_number }}</p>
            </span>
            <span slot="goods_name" slot-scope="text, record">
              <p
                class="goods-item"
                v-for="item in record.order_goods_list"
                :key="item.goods_id"
              >
                <span>{{ item.goods_id }}</span> /
                <span>{{
                  (item.goods_name && item.goods_name.split("，")[0]) ||
                  item.goods_name
                }}</span>
              </p>
            </span>
            <span slot="goods_number" slot-scope="text, record">
              <p
                class="goods-item"
                v-for="item in record.order_goods_list"
                :key="item.goods_id"
              >
                <span>{{ item.goods_number }}</span>
              </p>
            </span>
            <span slot="order_status" slot-scope="text">
              {{ order_status_list.find((item) => +item.value === +text).name }}
            </span>
            <!-- <span slot="action" slot-scope="text, record">
              <a @click="modify(record)">修改</a>
              <a-divider type="vertical" />
              <a>取消</a>
            </span> -->
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="page_no"
            :pageSize="page_size"
            :total="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </a-spin>
    <a-modal
      v-model="visible"
      title="手工发货"
      @ok="handleUpload"
      okText="导入手工发货信息"
      :ok-button-props="{ props: { loading: uploading } }"
    >
      <a-form-model layout="inline">
        <a-form-model-item label="选择平台">
          <a-select
            style="width: 200px"
            v-model="modalForm.platform"
            allowClear
            placeholder="平台"
            :dropdown-match-select-width="false"
          >
            <a-select-option
              :value="item.value"
              v-for="item in platformList"
              :key="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div class="flex align-center" style="margin-top: 10px">
        <a-upload
          name="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :file-list="fileList"
          :remove="handleRemove"
          :before-upload="beforeUpload"
        >
          <a-button> <a-icon type="upload" />选择文件 </a-button>
        </a-upload>
        <a
          href="http://odesk-test.oss-cn-shanghai.aliyuncs.com/72813497-3ec0-42dc-b184-792585c96e5f1616229663497example.xls"
          class="ml10"
          target="_blank"
        >
          <a-icon type="download" />下载模板
        </a>
      </div>
    </a-modal>
  </div>
</template>

<script>
import navBar from "@components/navBar";
import dateRangePicker from "@components/dateRangePicker";
import pagination from "@components/pagination";
import { baseURL } from "@config/config";
import { Modal } from "ant-design-vue";
export default {
  name: "orderList",
  components: {
    navBar,
    dateRangePicker,
    pagination,
  },
  data() {
    return {
      wrapperCol: { span: 24 },
      columns: [
        {
          dataIndex: "platform_order_sn",
          key: "platform_order_sn",
          title: "平台订单号",
        },
        {
          dataIndex: "platform_name",
          key: "platform_name",
          title: "平台名称",
          scopedSlots: { customRender: "platform_name" },
        },
        {
          title: "下单时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "昵称/ID",
          dataIndex: "user_nick",
          key: "user_nick",
          scopedSlots: { customRender: "user" },
        },
        {
          title: "收件人",
          dataIndex: "receiver_name",
          key: "receiver_name",
          scopedSlots: { customRender: "receiver_name" },
        },
        {
          title: "收件地址",
          dataIndex: "shipping_address",
          key: "shipping_address",
          scopedSlots: { customRender: "address" },
        },
        {
          title: "商品编码/商品名称",
          dataIndex: "goods_name",
          key: "goods_name",
          scopedSlots: { customRender: "goods_name" },
        },
        {
          title: "数量",
          dataIndex: "goods_number",
          key: "goods_number",
          scopedSlots: { customRender: "goods_number" },
        },
        {
          title: "快递面单",
          dataIndex: "shipping_name",
          key: "shipping_name",
          scopedSlots: { customRender: "shipping" },
        },
        {
          title: "状态",
          dataIndex: "order_status",
          key: "order_status",
          scopedSlots: { customRender: "order_status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      form: {
        order_sn_list: undefined,
        tracking_number_list: undefined,
        orderTime: undefined,
        receiveTime: undefined,
        payTime: undefined,
        goods_name: undefined,
        mobile: undefined,
        shipping_id: undefined,
        order_status: "0",
        pay_status: undefined,
        note: undefined,
        start_date: undefined,
        end_date: undefined,
        platform: undefined,
      },
      order_status_list: [
        {
          name: "待发货",
          value: "0",
        },
        // {
        //   name: "待打印",
        //   value: "1",
        // },
        // {
        //   name: "待发货",
        //   value: "2",
        // },
        {
          name: "已发货",
          value: "3",
        },
        {
          name: "已取消",
          value: "4",
        },
        {
          name: "已退款",
          value: "5",
        },
      ],
      shipping_list: [
        {
          name: "中通",
          value: 1,
        },
        {
          name: "圆通",
          value: 2,
        },
        {
          name: "申通",
          value: 3,
        },
        {
          name: "百世汇通",
          value: 4,
        },
        {
          name: "韵达",
          value: 5,
        },
        {
          name: "顺丰",
          value: 6,
        },
        {
          name: "邮政小包",
          value: 17,
        },
        {
          name: "极兔",
          value: 23,
        },
      ],
      page_no: 1,
      page_size: 10,
      total: 0,
      visible: false,
      fileList: [],
      uploading: false,
      loading: false,
      tab_list: [
        {
          id: 1,
          value: "全部",
        },
        {
          id: 2,
          value: "未打印",
        },
        {
          id: 3,
          value: "已打印",
        },
        {
          id: 4,
          value: "已发货",
        },
      ],
      table_data: [],
      platformList: [
        {
          text: "趣头条",
          value: "qtt",
        },
        {
          text: "滴滴果园",
          value: "didi_fruit",
        },
        {
          text: "oppo",
          value: "oppo",
        },
      ],
      modalForm: {
        platform: "didi_fruit",
      },
    };
  },
  computed: {
    platformNameMapping() {
      let obj = {};
      this.platformList.forEach((item) => {
        obj[item.value] = item.text;
      });
      return obj;
    },
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    paginate(data) {
      this.page_no = data.page_no;
      this.page_size = data.page_size;
      this.$nextTick(() => {
        this.getOrderList();
      });
    },
    async getOrderList() {
      this.loading = true;
      let data = {
        // shop_id: 1,
        goods_name: this.form.goods_name,
        mobile: this.form.mobile,
        shipping_id: this.form.shipping_id,
        order_status: this.form.order_status,
        start_date: this.form.start_date,
        end_date: this.form.end_date,
        platform: this.form.platform,
        page_no: this.page_no,
        page_size: this.page_size,
      };
      if (this.form.order_sn_list) {
        data.order_sn_list = this.form.order_sn_list.split(",");
      }
      if (this.form.tracking_number_list) {
        data.tracking_number_list = this.form.tracking_number_list.split(",");
      }
      let res = await this.$axios({
        url: this.$api.getOrderList,
        data,
      });
      this.loading = false;
      if (res.result) {
        this.total = res.result.total || 0;
        this.table_data = res.result.order_list;
      }
    },
    changeTab() {
      this.$nextTick(() => {
        this.getOrderList();
      });
    },
    get_order_time(date) {
      // console.log(date);
      this.form.start_date = date.start_time;
      this.form.end_date = date.end_time;
    },
    // onChange2(date, dateString) {
    //   console.log(date, dateString);
    // },
    // onChange3(date, dateString) {
    //   console.log(date, dateString);
    // },
    onExport() {
      let url = baseURL + this.$api.exportOrder + "?shop_id=1";
      // 全部的情况下，不穿status字段
      if (this.form.order_sn_list) {
        url += "&order_sn_list=" + this.form.order_sn_list;
      }
      if (this.form.tracking_number_list) {
        url += "&tracking_number_list=" + this.form.tracking_number_list;
      }
      if (this.form.start_date) {
        url += "&start_date=" + this.form.start_date;
      }
      if (this.form.end_date) {
        url += "&end_date=" + this.form.end_date;
      }
      if (this.form.order_status) {
        url += "&order_status=" + this.form.order_status;
      }
      if (this.form.mobile) {
        url += "&mobile=" + this.form.mobile;
      }
      if (this.form.goods_name) {
        url += "&goods_name=" + this.form.goods_name;
      }
      if (this.form.shipping_id) {
        url += "&shipping_id=" + this.form.shipping_id;
      }
      if (this.form.platform) {
        url += "&platform=" + this.form.platform;
      }
      url = url.replace(/\+/g, encodeURIComponent("+"));
      window.open(url);
    },
    resetForm() {
      // this.$refs.ruleForm.resetFields();
      this.form = {
        order_sn_list: undefined,
        tracking_number_list: undefined,
        orderTime: undefined,
        receiveTime: undefined,
        payTime: undefined,
        goods_name: undefined,
        mobile: undefined,
        shipping_id: undefined,
        order_status: "0",
        pay_status: undefined,
        note: undefined,
        start_date: undefined,
        end_date: undefined,
      };
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    handleUpload() {
      const { fileList } = this;
      if (!this.modalForm.platform) {
        this.$message.warning("请选择平台");
        return;
      }
      if (fileList.length === 0) {
        this.$message.warning("请上传文件");
        return;
      }
      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append("file", file);
      });
      formData.append("platform", this.modalForm.platform);
      this.uploading = true;
      this.$axios({
        url: this.$api.batchShip,
        processData: false,
        data: formData,
      })
        .then((res) => {
          this.fileList = [];
          this.uploading = false;
          this.visible = false;
          let failed_map = res.result.failed_map || {};
          let list = Object.keys(failed_map);
          if (list.length === 0) {
            this.$message.success("发货成功");
          } else {
            Modal.error({
              title: "发货失败记录",
              content: JSON.stringify(failed_map),
            });
          }
        })
        .catch(() => {
          this.uploading = false;
        });
    },
    modify(item) {
      console.log(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-demo {
  margin-bottom: 10px;
}
.align-center {
  align-items: center;
}
</style>

<style lang="scss">
.order-list .ant-tabs-tab {
  padding: 16px !important;
}
</style>
